import { useCallback, useEffect, useState } from "react";

const KEY_COMPANY = "fiscal.selectedCompanyId";
const KEY_FY = "fiscal.selectedFiscalYearId";

function readNumber(key: string): number | null {
  try {
    const v = window.localStorage.getItem(key);
    if (!v) return null;
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

/**
 * Persiste (companyId, fiscalYearId) entre páginas via localStorage.
 *
 * Quando companyId muda, fiscalYearId é resetado (a seleção é stale — FY
 * pertence a outra empresa).
 */
export function useFiscalSelection() {
  const [companyId, setCompanyIdState] = useState<number | null>(() => readNumber(KEY_COMPANY));
  const [fiscalYearId, setFiscalYearIdState] = useState<number | null>(() => readNumber(KEY_FY));

  useEffect(() => {
    if (companyId === null) {
      window.localStorage.removeItem(KEY_COMPANY);
    } else {
      window.localStorage.setItem(KEY_COMPANY, String(companyId));
    }
  }, [companyId]);

  useEffect(() => {
    if (fiscalYearId === null) {
      window.localStorage.removeItem(KEY_FY);
    } else {
      window.localStorage.setItem(KEY_FY, String(fiscalYearId));
    }
  }, [fiscalYearId]);

  const setCompanyId = useCallback((id: number) => {
    setCompanyIdState(id);
    setFiscalYearIdState(null);
  }, []);

  return {
    companyId,
    fiscalYearId,
    setCompanyId,
    setFiscalYearId: setFiscalYearIdState,
  };
}
